/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: 0;
  --gap: var(--nve-ref-space-xxs);
  --width: min-content;
  --max-width: 100%;
  --min-width: 170px;
  --max-height: 100%;
  width: var(--width);
  min-width: var(--min-width);
  contain: layout;
  content-visibility: auto;
  contain-intrinsic-size: auto var(--max-height, initial);
}

[internal-host] {
  padding: var(--padding);
  gap: var(--gap);
  display: flex;
  flex-direction: column;
  width: var(--width);
  min-width: var(--min-width);
  max-width: var(--max-width);
  max-height: var(--max-height);
  margin: 0;
  overflow-y: auto;
  scrollbar-color: var(--nve-sys-scrollbar-thumb-color) var(--nve-sys-scrollbar-track-color);
  scrollbar-width: var(--nve-sys-scrollbar-width);
}
